import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Sector } from "@/graphql/types";
import { onMounted, ref } from "vue";
import { useSectors } from "./hooks/useSectors";
import { AutoCompleteCompleteEvent } from "primevue/autocomplete";


export default /*#__PURE__*/_defineComponent({
  __name: 'SectorAutocomplete',
  props: {
    excludeId: {},
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const selectedCountry = ref<Sector>(null);
const filteredCategories = ref<Sector[]>([]);
const { sectors } = useSectors();

const searchCountry = ({ query }: AutoCompleteCompleteEvent) => {
  const parents = sectors.value.filter((c) => c.id !== props?.excludeId);
  if (!query.trim().length) {
    filteredCategories.value = parents;
  } else {
    filteredCategories.value = parents.filter((sector: Sector) => {
      return sector.name.toLowerCase().includes(query.toLowerCase());
    });
  }
};

const onUpdate = (event?: Sector | string) => {
  if (typeof event === "object") {
    emit("update:modelValue", event?.id);
  } else if (!event) {
    emit("update:modelValue", null);
  }
};

onMounted(() => {
  if (props.modelValue) {
    selectedCountry.value = sectors.value.find(
      ({ id }) => id === props.modelValue
    );
  }
});

return (_ctx: any,_cache: any) => {
  const _component_AutoComplete = _resolveComponent("AutoComplete")!

  return (_openBlock(), _createBlock(_component_AutoComplete, {
    "force-selection": true,
    modelValue: selectedCountry.value,
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => ((selectedCountry).value = $event)),
      onUpdate
    ],
    suggestions: filteredCategories.value,
    "complete-on-focus": "",
    onComplete: _cache[1] || (_cache[1] = ($event: any) => (searchCountry($event))),
    dropdown: true,
    field: "name",
    "scroll-height": "150px"
  }, null, 8, ["modelValue", "suggestions"]))
}
}

})